import { themeAtom } from "../../shared/atoms";
import { PnlTableRowProps } from "../models/PnlTableRow.model";
import {
  formatNumberWithDots,
  excludedRows,
  rowsWithDays,
  formatDaysWithDots,
  getPnlRowsStyling,
} from "../utils/UtilFunctions";
import { useAtomValue } from "jotai";
import React from "react";
import { twMerge } from "tailwind-merge";

const PnlTableRow: React.FC<PnlTableRowProps> = ({
  category,
  estimate,
  actual,
  variance,
  unallocated,
  continueClicked,
}) => {
  const theme = useAtomValue(themeAtom);

  const pnLRowClass = () => {
    const background = getPnlRowsStyling(category);
    if (background === "Green") return theme.voyPnl.rowGreenBg;
    if (background === "Red") return theme.voyPnl.rowRedBg;
    if (background === "Default") return theme.home.tailwind.backgound;
  };

  const rowWithDay = rowsWithDays.includes(category);

  return (
    <tr className={twMerge("h-[44px] border-t", pnLRowClass(), theme.uwhcAssistant.border)}>
      <td className="h-full px-4 text-left font-semibold">{category}</td>
      {!continueClicked && (
        <>
          <td className="h-full px-4">{rowWithDay ? formatDaysWithDots(estimate) : formatNumberWithDots(estimate)}</td>
          <td className="h-full px-4">{rowWithDay ? formatDaysWithDots(actual) : formatNumberWithDots(actual)}</td>
        </>
      )}
      <td className="h-full px-4">{rowWithDay ? formatDaysWithDots(variance) : formatNumberWithDots(variance)}</td>

      <td className="h-full px-4">
        {excludedRows.includes(category)
          ? "-"
          : rowWithDay
            ? formatDaysWithDots(unallocated)
            : formatNumberWithDots(unallocated)}
      </td>
    </tr>
  );
};

export default PnlTableRow;
